import { filterLocations, mockInvestors } from "@/frontend/components/filter/const/const";
import { TFormDataState, TFundingRound } from "../model/types/types";

export const companiesSidebarList = [
  // { label: "Companies", value: "Companies" }
  // { label: "Add Companies", value: "Add Companies" },
  // { label: "Pipelines", value: "Pipelines" },
  // { label: "Add Pipelines", value: "Add Pipelines" },
  // { label: "Investors", value: "Investors" },
  // { label: "Add Investors", value: "Add Investors" },
  // { label: "Partners", value: "Partners" },
  // { label: "Add Partners", value: "Add Partners" },
  // { label: "Settings", value: "Settings" }
];

export const industriesMockData = [
  { label: "Software", value: "Software" },
  { label: "Healthcare", value: "Healthcare" },
  { label: "Retail", value: "Retail" },
  { label: "Other", value: "Other" }
];

export const tagsMockData = [
  { label: "Tag 1", value: "Tag 1" },
  { label: "Tag 2", value: "Tag 2" },
  { label: "Tag 3", value: "Tag 3" },
  { label: "Tag 4", value: "Tag 4" },
  { label: "Tag 5", value: "Tag 5" },
  { label: "Tag 6", value: "Tag 6" },
  { label: "Tag 7", value: "Tag 7" },
  { label: "Tag 8", value: "Tag 8" },
  { label: "Tag 9", value: "Tag 9" }
];

export const investorsMockData = [
  { label: "John Doe", value: "John Doe" },
  { label: "Jane Doe", value: "Jane Doe" },
  { label: "John Smith", value: "John Smith" },
  { label: "Jane Smith", value: "Jane Smith" },
  { label: "John Johnson", value: "John Johnson" },
  { label: "Jane Johnson", value: "Jane Johnson" },
  { label: "John Williams", value: "John Williams" },
  { label: "Jane Williams", value: "Jane Williams" },
  { label: "John Brown", value: "John Brown" }
];

export const latestFundingRound: TFundingRound = {
  "Pre-Seed": false,
  Seed: false,
  "Series A": false,
  "Series B": false,
  "Series C": false,
  "Series D": false,
  "Series E+": false,
  Private: false,
  Undetermined: false,
  "IPO/Public Market": false,
  "Merge/Private Acquisition": false,
  "Out of Business": false,
  Grant: false,
  "Debt Financing": false
};

export const initialFilterData: TFormDataState = {
  aiPitchDescription: "",
  funding: { min: "", max: "" },
  foundingYear: { min: "", max: "" },
  lastFundingDateFrames: [],
  locationValue: "",
  financialStageFilters: latestFundingRound,
  formData: {
    listData: companiesSidebarList,
    location: filterLocations,
    tags: [],
    investors: investorsMockData,
    industries: industriesMockData
  },
  formTags: {
    listData: [],
    location: [],
    tags: [],
    investors: [],
    industries: []
  }
};
